export default __webpack_public_path__ + "static/media/demo0.c6a2e670.png";